import GoalSelection from '../../components/action_plans/GoalSelection'
import { createApp } from 'vue';

if (document.getElementById('goal-selection-container')) {
    const app = createApp({
        components: {
            GoalSelection
        }
    });
    app.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app.mount('#goal-selection-container');
}